<div class="flex">
    <div *ngIf="proratedLinePrice" class="me-3">
        <label for="linePrice">Gesamtpreis(netto)</label>
        <!-- <input  name="linePrice" class="form-control col-md-1" type="number" [(ngModel)]="proratedLinePrice" [disabled]="true"> -->
        <div id="linePrice" class="form-control col-md-1 disabled-field">
            {{ proratedLinePrice | decimalPlacesCustom: decimalPlacesInputSettings }}
        </div>
    </div>
    <div *ngIf="taxAmount" class="me-3">
        <label for="tax">Steuer</label>
        <!-- <input  name="tax" class="form-control col-md-1" type="number" [(ngModel)]="taxAmount" [disabled]="true"> -->
        <div id="tax" class="form-control col-md-1 disabled-field">
            {{ taxAmount | decimalPlacesCustom: decimalPlacesInputSettings }}
        </div>
    </div>
    <div *ngIf="proratedLinePriceWithTax" class="me-3">
        <label for="proratedLinePriceWithTax">Gesamtpreis(brutto)</label>
        <!-- <input  name="tax" class="form-control col-md-1" type="number" [(ngModel)]="proratedLinePriceWithTax" [disabled]="true"> -->
        <div id="proratedLinePriceWithTax" class="form-control col-md-1 disabled-field">
            {{ proratedLinePriceWithTax | decimalPlacesCustom: decimalPlacesInputSettings }}
        </div>
    </div>
    <div *ngIf="revenue">
        <label for="revenue">Erlös</label>
        <!-- <input  name="tax" class="form-control col-md-1" type="number" [(ngModel)]="revenue" [disabled]="true"> -->
        <div id="revenue" class="form-control col-md-1 disabled-field">
            {{ revenue | decimalPlacesCustom: decimalPlacesInputSettings }}
        </div>
    </div>
</div>
